import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import type { SingleValueProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import type { FieldDataType } from '@feathr/blackbox';
import type { ISelectOption } from '@feathr/components';
import { fieldDataTypeIcon } from '@feathr/extender/styles/fieldDataType';

function DataTypeSingleValue(props: SingleValueProps<ISelectOption>): JSX.Element {
  const { data } = props;

  const icon = fieldDataTypeIcon(data.id as FieldDataType);

  return (
    <components.SingleValue {...props}>
      {icon && <FontAwesomeIcon icon={icon} />}
      {data.name}
    </components.SingleValue>
  );
}

export default DataTypeSingleValue;
